import { graphql, useStaticQuery } from "gatsby"
import type { Link } from "@gatsby-plugin-onestore/fragments/link"
import type { Navigation } from "@gatsby-plugin-onestore/fragments/navigation"
import type { GaEvent } from "~/fragments/gaEvent"
import type { EmbeddedAssetSquidexMetadata } from "~/fragments/image"

type MenuFlatData = {
  siteName: string
  mobileNavigationBackLinkText: string
  logo: EmbeddedAssetSquidexMetadata[]
  logoDarkMode: EmbeddedAssetSquidexMetadata[]
  gaLogoEvent?: GaEvent
  navigation: Navigation[]
  links: Link[]
  gaCartEvent?: GaEvent
}

export type Menu = {
  __typename: string
  flatData: MenuFlatData
}

type Query = {
  GraphCmsSquidex: {
    findPageMenuSingleton: Menu
  }
}

type MenuQueryResult = {
  menu: Menu
}

export default function useMenuQuery(): MenuQueryResult {
  const { GraphCmsSquidex } = useStaticQuery<Query>(graphql`
    {
      GraphCmsSquidex {
        findPageMenuSingleton {
          __typename
          flatData {
            siteName
            mobileNavigationBackLinkText
            logo {
              ...Image
            }
            logoDarkMode {
              ...Image
            }
            gaLogoEvent {
              ...GaEvent
            }
            navigation {
              ...NavigationElement
            }
            links {
              ...Link
            }
            gaCartEvent {
              ...GaEvent
            }
          }
        }
      }
    }
  `)

  return {
    menu: GraphCmsSquidex.findPageMenuSingleton,
  }
}
